import { Eye, Users, Heart, Lightning, Crown, Sun } from "@phosphor-icons/react";

const PRINCIPLES = [
  { icon: Eye, k: "01", t: "Transparency", d: "Decisions and models are explainable in plain language." },
  { icon: Users, k: "02", t: "Plurality", d: "No single culture, lab, or company defines the future." },
  { icon: Heart, k: "03", t: "Healing", d: "AI must measurably increase the conditions for life." },
  { icon: Lightning, k: "04", t: "Wisdom", d: "Elders and indigenous knowledge sit at the same table as engineers." },
  { icon: Crown, k: "05", t: "Sovereignty", d: "Communities retain control over data, models, and outcomes." },
  { icon: Sun, k: "06", t: "Joy", d: "If it doesn't move us toward beauty and meaning, it's not progress." },
];

export default function AICouncil() {
  return (
    <div data-testid="page-council">
      <section className="relative">
        <div className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url(https://images.unsplash.com/photo-1782015941315-c879b97866de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGFydGlmaWNpYWwlMjBpbnRlbGxpZ2VuY2UlMjBnb2xkfGVufDB8fHx8MTc4MjA5NDc2NHww&ixlib=rb-4.1.0&q=85)" }}
          aria-hidden
        />
        <div className="absolute inset-0 bg-ink/75" aria-hidden />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-32 lg:py-44 text-white">
          <p className="overline text-gold">AI Council</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight max-w-5xl">
            A charter for peaceful collaboration between humans and AI.
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-white/80 leading-relaxed">
            The Council convenes researchers, ethicists, indigenous knowledge
            holders, and engineers around a single question: what does AI in
            service of life look like?
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-24 lg:py-32" data-testid="council-principles">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <p className="overline">The Charter</p>
            <h2 className="mt-3 font-display text-3xl lg:text-5xl font-light tracking-tight text-ink leading-[1.05]">
              Six principles. One commitment.
            </h2>
          </div>
          <p className="lg:col-span-6 lg:col-start-7 text-lg text-ink/70 leading-relaxed">
            These are our working principles — proposed openly and refined in
            public. Signatories include labs, communities, and individuals across
            five continents.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {PRINCIPLES.map((p) => {
            const Icon = p.icon;
            return (
              <div key={p.t} className="bg-white rounded-2xl ring-1 ring-ink/10 p-8 card-shadow hover:-translate-y-1 transition-transform" data-testid={`principle-${p.t.toLowerCase()}`}>
                <div className="flex items-start justify-between">
                  <div className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-ink text-gold">
                    <Icon size={22} weight="duotone" />
                  </div>
                  <span className="font-display text-3xl text-ink/15">{p.k}</span>
                </div>
                <h3 className="mt-6 font-display text-2xl text-ink">{p.t}</h3>
                <p className="mt-2 text-ink/65 leading-relaxed">{p.d}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="bg-ink text-white">
        <div className="max-w-5xl mx-auto px-6 md:px-10 py-24 text-center">
          <p className="overline text-gold">Manifesto</p>
          <p className="mt-6 font-display text-2xl lg:text-4xl font-light leading-snug">
            “Intelligence — human or otherwise — earns its place by deepening the
            conditions for life. Anything else is noise dressed as progress.”
          </p>
          <p className="mt-6 text-white/60 text-sm tracking-wider">— Drafted by the AI Council, 2026</p>
        </div>
      </section>
    </div>
  );
}
